import { render, staticRenderFns } from "./memorial.vue?vue&type=template&id=53e44380&scoped=true"
import script from "./memorial.vue?vue&type=script&lang=js"
export * from "./memorial.vue?vue&type=script&lang=js"
import style0 from "./memorial.vue?vue&type=style&index=0&id=53e44380&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e44380",
  null
  
)

export default component.exports